/**
 * SproutIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SproutIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.494 23a.94.94 0 0 1-.68-.267.9.9 0 0 1-.275-.662v-8.897q-1.915 0-3.671-.705a9.5 9.5 0 0 1-3.103-2.014 9 9 0 0 1-2.056-3.017A9.2 9.2 0 0 1 1 3.868v-.76q0-.47.327-.79Q1.654 2 2.14 2h.783q1.875 0 3.628.71a9.5 9.5 0 0 1 3.102 2.02 8.8 8.8 0 0 1 1.64 2.171q.64 1.2.917 2.547.22-.371.49-.704.272-.332.605-.656a9.5 9.5 0 0 1 3.103-2.019 9.7 9.7 0 0 1 3.67-.712h.784q.484 0 .811.319.328.318.328.788v.762a9 9 0 0 1-.732 3.568 9.2 9.2 0 0 1-2.077 3.018 9.3 9.3 0 0 1-3.087 1.999q-1.74.69-3.655.689v5.571a.9.9 0 0 1-.275.662.94.94 0 0 1-.68.267m-.943-11.714a7 7 0 0 0-.589-2.832 7.5 7.5 0 0 0-1.671-2.4A7.8 7.8 0 0 0 5.823 4.43a7.6 7.6 0 0 0-2.913-.573q0 1.486.573 2.848A7.3 7.3 0 0 0 5.14 9.119a7.5 7.5 0 0 0 2.483 1.61q1.4.557 2.93.557m1.898 3.357q1.528 0 2.913-.557a7.6 7.6 0 0 0 2.467-1.61 7.5 7.5 0 0 0 1.672-2.414 7.1 7.1 0 0 0 .589-2.848q-1.528 0-2.93.573a7.7 7.7 0 0 0-2.482 1.625 7.3 7.3 0 0 0-1.656 2.399 7.2 7.2 0 0 0-.573 2.832" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SproutIcon = makeIcon('SproutIcon', SproutIconSvg)
